import React, { Component } from 'react';
import classNames from 'classnames';
import { Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

export default class PriceLevel extends Component {
  render() {
    const titleClass = classNames({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label')
    const { input, isRequired } = this.props;
    return (
      <div className="price-level-setup boolean-field">
        {this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}
        <label className={titleClass}><Translate value="price_level_percent" />{isRequired && <span className="asteriksReq">*</span>}</label>
          <div className="boolean-input">
            <label className="boolean">
              <Input {...input} type="radio" value="1" checked={input.value === 1 || input.value === '1' } /><Translate value="lv1" />
            </label>
            <label className="boolean">
              <Input {...input} type="radio" value="2" checked={input.value === 2 || input.value === '2' } /><Translate value="lv2" />
            </label>
            <label className="boolean">
              <Input {...input} type="radio" value="3" checked={input.value === 3 || input.value === '3' } /><Translate value="lv3" />
            </label>
            <label className="boolean">
              <Input {...input} type="radio" value="4" checked={input.value === 4 || input.value === '4' } /><Translate value="lv4" />
            </label>
            <label className="boolean">
              <Input {...input} type="radio" value="5" checked={input.value === 5 || input.value === '5' } /><Translate value="lv5" />
            </label>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/priceLevel.jsx